/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React from 'react';
import ReactDOM from 'react-dom';
import store from 'reducers/store';
import { isInIFrame } from 'helpers/iframeHelpers';
import { Provider } from 'react-redux';
import ViewContainer from 'src/views/ViewContainer';
import ResourceModal from 'src/resource-modal/ResourceModal';

/** Load React View from JSP */
window.setView = view => {
  const w = isInIFrame() ? window.parent : window;

  if (!w.MetadataView) {
    w.addEventListener('react-load', () => {
      w.MetadataView.setView(view);
    });
  } else {
    w.MetadataView.setView(view);
  }
};

/** Embed React view into DOM */
window.embed = (id, frame, view) => {
  const w = isInIFrame() ? window.parent : window;

  if (!w.MetadataView) {
    w.addEventListener('react-load', () => {
      w.MetadataView.embed(id, frame, view);
    });
  } else {
    w.MetadataView.embed(id, frame, view);
  }
};

// on PAGE LOAD (script import in index.jsp
/** Create divs to DOM rendering Metadata views & Modal */
window.addEventListener('load', function() {
  let viewContainer = window.parent.document.querySelector('#react-view');
  
  // If in iframe + has template, leave loading for template
  if (isInIFrame() && viewContainer) {
    return;
  }
  const container = window.parent.document.querySelector('.content') || document.body;

  // Global functions for View
  window.MetadataView = {};

  let viewDiv = document.createElement('div');
  viewDiv.setAttribute('id', 'react-view');
  viewDiv.setAttribute('style', 'height: 100%;');
  container.appendChild(viewDiv);

  // Global functions for Modal
  window.ResourceModal = {};

  ReactDOM.render(
    <Provider store={store}>
      <ViewContainer />
      <ResourceModal />
    </Provider>, viewDiv);
});